export enum EmbedType {
  PARTICIPANTS = 'participants',
  MEETING_RESULT = 'meetingResult',
  MEETING_INFO = 'meetingInfo',
}

export interface MeetingSummaryElementBase {
  displayId: string
}

export interface FreeTextElement extends MeetingSummaryElementBase {
  type: 'text'
  text: string
}

export interface EmbeddedElementBase extends MeetingSummaryElementBase {
  type: 'embed'
  embedType: EmbedType
  parameters: { [key: string]: any }
}

export interface ParticipantsElement extends EmbeddedElementBase {
  embedType: EmbedType.PARTICIPANTS
}

export interface MeetingResultElement extends EmbeddedElementBase {
  embedType: EmbedType.MEETING_RESULT
  parameters: {
    resultTypeId?: string
  }
}

export interface MeetingInfoElement extends EmbeddedElementBase {
  embedType: EmbedType.MEETING_INFO
}

export type EmbeddedElement = ParticipantsElement | MeetingResultElement | MeetingInfoElement

export type MeetingSummaryElement = FreeTextElement | EmbeddedElement

export interface MeetingSummaryElementProps<T extends MeetingSummaryElement> {
  element: T
  onChange?: (newElement: T) => void
}

export const ToolUseNameMap: Record<string, string> = {
  get_crm_info_for_contact: "Loading contact's details…",
  get_emails_for_contact: "Checking contact's recent emails…",
  get_past_meeting_info_for_contact: "Reviewing contact's past meeting…",
  get_tasks_for_contact: "Fetching contact's open tasks…",
  get_meeting_info: 'Loading meeting details…',
  get_meeting_info_with_allocation: 'Loading meeting details with participants…',
  get_meeting_results: 'Checking meeting results…',
  get_meeting_transcription: 'Loading meeting transcript…',
  get_calendar_events: 'Checking calendar events…',
  get_planning_info_for_contact: "Reviewing contact's planning notes…",
  get_portfolio_info_for_contact: "Loading contact's portfolio data…",
  get_tax_info_for_contact: "Checking contact's tax information…",
  get_meeting_preparation_email_template: 'Loading prep email template…',
  get_meeting_preparation_template: 'Getting prep template…',
  get_meeting_summary_template: 'Loading summary template…',
  get_meeting_summary_template_static_embeds: 'Loading summary assets…',
  update_meeting_results: 'Updating meeting results…',
  get_meeting_agenda: 'Checking meeting agenda…',
  list_offerable_user_actions: 'Checking available actions…',
  offer_user_action: 'Preparing action…',
  get_document_summary: 'Reading the summary…',
  edit_document_summary: 'Updating the summary…',
} as const
